import type { FloorPlanData } from '@shared/types/floorPlans';
import { CENTS_IN_DOLLAR } from '@shared/utils/currency';
import type { ListingWithShifts } from '../apiHelpers';
import type { ListingFormData } from '../types';

export const getDefaultFormValues = ({
  floorPlan,
  listing,
  isListingLoading,
  isDuplicating = false,
}: {
  floorPlan: FloorPlanData;
  listing: ListingWithShifts | null;
  isListingLoading: boolean;
  isDuplicating?: boolean;
}): ListingFormData => {
  if (!listing) {
    // Don't default the floorPlanId until the listing has finished loading.
    const floorPlanId = isListingLoading ? undefined : floorPlan.id;

    return {
      floorPlanId,
      highlightedTables: [],
      price: '0',
      shiftIds: [],
    } as unknown as ListingFormData;
  }

  return {
    floorPlanId: listing.floorPlanId,
    highlightedTables: floorPlan.floorPlanTables.filter((table) =>
      listing.highlightedFloorPlanTableIds.includes(table.id),
    ),
    iconName: listing.iconName,
    maximumGuests: listing.maximumGuests.toString(),
    minimumGuests: listing.minimumGuests.toString(),
    name: listing.name,
    publicName: `${listing.publicName}${isDuplicating ? ' - Copy' : ''}`,
    turnTime: listing.turnTime,
    price: (listing.price / CENTS_IN_DOLLAR).toString(),
    shiftIds: listing.shifts.map((window) => window.id),
  };
};
